import {Component, Input, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {Customer} from '@iw-shop/customer/models/customer';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {ArticleService} from '@iw-shop/article/services/article.service';
import {EnvironmentService} from '@iw-shop/core//services/environment.service';
import {ApiArticle} from '@api/articles';
import {ArticleTemplateService} from '@iw-shop/article/components/templates/article-template.service';
import {ConfigService} from "@iw-shop/config/service/config.service";
import {NumberFormat} from "@iw-shop/core/functions/number-format";
import {getSelectedCustomer} from "@store/selectors/user.selector";
import {faBars, faGrip, faImage, faSearch} from "@fortawesome/free-solid-svg-icons";
import {faImages} from "@fortawesome/free-regular-svg-icons";
import {UserService} from "@iw-shop/user/services/user.service";

@Component({
    selector: 'iw-shop-article-template-list',
    standalone: false,
    templateUrl: './article-list-template.component.html',
    styleUrls: ['./article-list-template.component.scss']
})
export class ArticleListTemplateComponent implements OnInit {

    @Input() article?: ApiArticle;
    @Input() articlesWithCommonRelatedGroup: ApiArticle[] = [];
    @Input() isNotification: boolean = true;

    resourceUrl?: any = null;

    customer$?: Observable<Customer | null | undefined>;

    articleContext?: any;

    constructor(
        private store: Store<AppState>,
        public articleTemplateService: ArticleTemplateService,
        public articleService: ArticleService,
        public userService: UserService,
        public configService: ConfigService,
        private environmentService: EnvironmentService) {
        this.customer$ = this.store.select(getSelectedCustomer);

    }

    ngOnInit(): void {
        this.resourceUrl = this.environmentService.environment.urlS3;
        this.articleContext = {
            $implicit: { // default
                article: this.article
            }
        };
    }

    getRelatedArticles(relatedGroup?: string) {
        return this.articlesWithCommonRelatedGroup.filter(a => a.relatedArticleGroup == relatedGroup);
    }

    protected readonly NumberFormat = NumberFormat;
    protected readonly faImages = faImages;
    protected readonly faGrip = faGrip;
    protected readonly faBars = faBars;
}
